import React from "react";

export function RefreshIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m11.5,2c2.29,0,4.39.83,6.03,2.19l-1.39,1.39,5.71,1.24-1.24-5.71-1.65,1.65c-2.01-1.72-4.61-2.77-7.46-2.77C5.16,0,0,5.16,0,11.5c0,.65.07,1.29.17,1.91l1.87-1.08c-.02-.27-.04-.55-.04-.83C2,6.26,6.26,2,11.5,2Z"
      />
      <path
        className="cls-1"
        d="m22.79,9.35l-1.86,1.07c.04.35.07.71.07,1.08,0,5.24-4.26,9.5-9.5,9.5-2.34,0-4.47-.86-6.13-2.27l1.37-1.57-5.78-.84,1.63,5.61,1.47-1.68c2.01,1.72,4.6,2.76,7.45,2.76,6.34,0,11.5-5.16,11.5-11.5,0-.74-.08-1.45-.21-2.15Z"
      />
    </svg>
  );
}
